<tt-card *ngIf="!!get" style="max-width: 160rem">
    <tt-field-group>
        <tt-input ttLabelView="top" ttLabel="dataimp_name" [ttModel]="get.dataimp_name" ttReadonly></tt-input>
        <tt-input ttLabelView="top" ttLabel="table_name_destination" [ttModel]="get.table_name_destination" ttReadonly></tt-input>
        <tt-input ttLabelView="top" ttLabel="url_excel_template" [ttModel]="get.url_excel_template" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button *ngIf="get.url_excel_template > ''" ttId="goto" ttIcon="fas fa-window-restore" (ttClick)="openUrl()"></tt-form-field-button>
            </ng-container>
        </tt-input>
    </tt-field-group>
    <tt-select
        *ngIf="get.show_pricelist_id === '1'"
        [ttRememberId]="'w_dodataimp.' + get.dataimp_keyno + '.pricelist_id'"
        ttLabelView="top"
        ttLabel="pricelist"
        [(ttModel)]="get.pricelist_id"
        (ttModelChange)="readGrid()"
        [ttData]="pricelists"
        ttShowClearButton
        ttClearValue=""
    ></tt-select>
    <tt-select
        *ngIf="get.show_language_id === '1'"
        [ttRememberId]="'w_dodataimp.' + get.dataimp_keyno + '.language_id'"
        ttLabelView="top"
        ttLabel="language"
        [(ttModel)]="get.language_id"
        (ttModelChange)="readGrid()"
        [ttData]="languages"
    ></tt-select>
    <tt-field-group>
        <tt-select
            *ngIf="get.show_prodgrp_id === '1'"
            [ttRememberId]="'w_dodataimp.' + get.dataimp_keyno + '.prodgrp_id'"
            ttLabelView="top"
            ttLabel="prodgrp"
            [(ttModel)]="get.prodgrp_id"
            (ttModelChange)="readGrid()"
            [ttData]="productGroups"
            ttShowClearButton
            ttClearValue=""
        ></tt-select>
        <tt-select
            *ngIf="get.show_prodtype_no === '1'"
            ttLabelView="top"
            ttLabel="prodtype"
            [(ttModel)]="get.prodtype_no"
            (ttModelChange)="readGrid()"
            [ttData]="productTypes"
            ttDataId="prodtype_no"
            ttDataName="prodtype_name"
            ttShowClearButton
            ttClearValue=""
        ></tt-select>
    </tt-field-group>
    <tt-select
        *ngIf="get.show_stockplace_id === '1'"
        [ttRememberId]="'w_dodataimp.stockplace_id'"
        ttLabelView="top"
        ttLabel="stockplace"
        [(ttModel)]="get.stockplace_id"
        [ttData]="stockplaces"
        ttDataId="stockplace_id"
        ttDataName="stockplace_name"
        ttShowClearButton
        ttClearValue=""
    ></tt-select>
    <tt-date-range
        *ngIf="get.show_datefomtom === '1'"
        [ttRememberId]="'w_dodataimp.' + get.dataimp_keyno"
        ttLabelView="top"
        ttLabel="date_fom_tom"
        [(ttStartDate)]="get.date_fom"
        [(ttEndDate)]="get.date_tom"
        [(ttInterval)]="get.dateselector_index"
    ></tt-date-range>
    <form (submit)="readGrid()">
        <tt-input *ngIf="get.show_searchtext === '1'" [ttRememberId]="'w_dodataimp.' + get.dataimp_keyno + '.searchtext'" ttLabelView="top" ttLabel="searchtext" [(ttModel)]="get.searchtext">
            <ng-container buttons>
                <tt-form-field-button ttId="search" ttIcon="fas fa-search" (ttClick)="readGrid()"></tt-form-field-button>
            </ng-container>
        </tt-input>
    </form>
</tt-card>
<tt-grid *ngIf="!!grid" class="flex-1" style="min-height: 500px" [(ttOptions)]="grid"> </tt-grid>
